/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type MediaList_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FaceMediaList_offer$ref: FragmentReference;
declare export opaque type FaceMediaList_offer$fragmentType: FaceMediaList_offer$ref;
export type FaceMediaList_offer = {|
  +$fragmentRefs: MediaList_offer$ref,
  +$refType: FaceMediaList_offer$ref,
|};
export type FaceMediaList_offer$data = FaceMediaList_offer;
export type FaceMediaList_offer$key = {
  +$data?: FaceMediaList_offer$data,
  +$fragmentRefs: FaceMediaList_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FaceMediaList_offer",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "MediaList_offer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6f90468c1bc56b5256f0eacb5cd73ea8';

module.exports = node;
